import React, { useReducer } from 'react';
import { Route, Routes, useNavigate } from 'react-router-dom';
import App from './App';
import Detail from './Detail';
import Category from './Category'
import Subcategory from './Subcategory';
import { Content } from './globalType';
import HomeSubcategory from './HomeSubcategory';
import Live from './live';
import MainCategory from './MainCategory';
import Emag from './Emag'


interface State {
  page: string;
  content: Content | null;
}

type Action =
  | { type: 'SET_PAGE', page: string, content: Content | null}


function Main() {
  const navigate = useNavigate()
  const [state, dispatch] = useReducer((state: State, action: Action) => {
    switch(action.type) {
      case 'SET_PAGE':
        return {
          ...state,
          page: action.page,
          content: action.content,
        }
    }
  }, {
    page: 'home',
    content: null,
  })

  const goToPage = (page:string, content: Content | null) => {
    //dispatch({type: 'SET_PAGE', page, content})
    navigate(page)
  }

  const goToSubcategory = (page:string, subcategories: Content[]) => {
    
  }

  return (
    <Routes>
      <Route path="/ondemand/emagazine" element={<Emag goToPage={goToPage} />} />
      <Route path="/ondemand/detail/:contentId" element={<Detail baseContent={state.content} goToPage={goToPage} />} />
      <Route path="/ondemand/schedule/:categorySlug/:datetime" element={<Live goToPage={goToPage} />} />
      <Route path="/ondemand/schedule/:categorySlug" element={<Live goToPage={goToPage} />} />
      <Route path="/ondemand/schedule" element={<Live goToPage={goToPage} />} />
      <Route path="/ondemand/home/:subcategorySlug" element={<HomeSubcategory goToPage={goToPage} />} />
      <Route path="/ondemand/:shelfSlug" element={<MainCategory goToPage={goToPage} />} />
      <Route path="/ondemand" element={<App goToPage={goToPage} />} />
    </Routes>
  )
}

export default Main;